/**
 * Determine where the decision control elements are, and apply event listeners
 * to each for control of fullpage.js.
 */
const initialiseDecision = () => {
  // The available decisions should be added to the Array below, in the following format:
  //  [
  //    [
  //      HTMLElement,
  //      Function to run when clicked,
  //    ]
  //  ]
  let availableDecisions = [
    [document.getElementsByClassName('js--decision-choice-1')[0], fullpage_api.moveSlideLeft],
    [document.getElementsByClassName('js--decision-choice-2')[0], fullpage_api.moveSlideRight],
  ];

  // Iterate through all available decisions and the settings applied.
  availableDecisions.forEach((decision) => {
    // Attach the event listener to the current decision's HTML element.
    decision[0].addEventListener(
      'click',
      () => {
        // When the event is triggered, run the supplied function.
        decision[1]();
      },
      false,
    );
  });
};

exports.initialiseDecision = initialiseDecision;
